import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { IAppState } from '../../store/interface/app.state.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IUser } from '../../user/interfaces/user.interface';

/*=====================================
  Keeps the user-management screens pointed at other people.

  The list already hides the pencil on your own row, but the address can still
  be typed by hand. Without this the form would open, be filled in, and only
  then be refused by the API — so the refusal is moved to the door. Manage
  profile is where your own details are changed, so that is where this sends
  you.
======================================*/
@Injectable()
export class NotSelfGuard implements CanActivate {
    constructor(
        private store: Store<IAppState>,
        private router: Router,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> {
        return this.store
            .select((state) => state.user.loggedInUser)
            .pipe(
                map((user: IUser | null) =>
                    user && route.paramMap.get('id') === user.id
                        ? this.router.parseUrl('/user/manage-profile')
                        : true,
                ),
            );
    }
}
